import * as React from 'react';
import { TDeviceType } from '@cian/ui-kit';

import { FormModalLayout } from '../FormLayout';
import { trackShow } from './tracking';
import { ENewReviewStep, EStartReviewErrorCode } from '../../types/newReview';
import { mapErrorToDisplay } from './utils/mapErrorToDisplay';

interface IDailyrentNewReviewAccessRejectionProps {
  isOpened: boolean;
  onClose(): void;
  deviceType: TDeviceType;
  objectId: number;
  errorCode: EStartReviewErrorCode;
  onBookClick(): void;
  onRequestAuth(): void;
  onReload(): void;
}

export const DailyrentNewReviewAccessRejection = ({
  isOpened,
  onClose,
  errorCode,
  deviceType,
  objectId,
  onBookClick,
  onRequestAuth,
  onReload,
}: IDailyrentNewReviewAccessRejectionProps) => {
  const errorContent = React.useMemo(
    () =>
      mapErrorToDisplay(errorCode, {
        onClose,
        onBookClick,
        onRequestAuth,
        onReload,
      }),
    [errorCode, onClose, onBookClick, onReload],
  );

  React.useEffect(() => {
    trackShow(objectId, errorCode, deviceType);
  }, []);

  return (
    <FormModalLayout
      testId="DailyrentNewReviewAccessRejection"
      shortTitle="Новый отзыв"
      open={isOpened}
      onClose={onClose}
      type="info"
      step={ENewReviewStep.Error}
    >
      {errorContent}
    </FormModalLayout>
  );
};
